import React from "react";
import { SingleSignOnPendingComponent } from "./SingleSignOnPendingComponent";
import { ssoMessages } from "../StepSSO/StepSSOComponent";
import { VerificationStepsEnum } from "../../lib/types/runtimeTypes";

interface SSOPendingProps {
  logo: React.ReactNode;
  cancelSSO: () => void;
}

const SSOPending = ({ logo, cancelSSO }: SSOPendingProps) => (
  <SingleSignOnPendingComponent
    stepName={VerificationStepsEnum.sso}
    messages={ssoMessages}
    logo={logo}
    cancelSingleSignOn={cancelSSO}
  />
);

export const SSOPendingComponent = SSOPending;
